import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const Container = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;

    a:not(:last-child) {
        margin-right: 12px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;

        a:not(:last-child) {
            width: 100%;
            margin-right: 0;
            margin-bottom: 12px;
        }

        a > div {
            justify-content: center;
        }
    }
`;
